import { cloneDeep, mapKeys } from 'lodash-es'
import { PermissionRole } from '../auth/type'
import type { Channel, OrgActiveParams } from '@/store/modules/channel-framework/types'
import { defaultChannel } from '@/store/modules/channel-framework/constant'
import stores from '@/store'
import { OrgTreeType } from '@/api/base/enums'

const store = defineStore('channelFramework', () => {
  const channels = ref<Channel[]>([])
  const { setRole } = stores.permissionStore
  // 是否折叠 true：折叠，false：打开
  const collapsed = ref(true)
  // 是否展示折叠
  const showCollapsed = ref(true)
  // 当前激活的渠道
  const activeChannel = ref<Channel>(cloneDeep(defaultChannel))
  // 当前激活的视图 渠道树/用户
  const activeOrgTreeType = ref<OrgTreeType>(OrgTreeType.Channel)
  // 是否允许编辑
  const editable = ref(false)

  // 是否是超级管理员
  const { superAdmin } = storeToRefs(stores.authStore)
  const currentRolePermission = ref<PermissionRole>(PermissionRole.Guest)

  // 渠道相关的参数
  const orgActiveParams = computed<OrgActiveParams>(() => ({
    channelOrgId: activeChannel.value.id,
    saleUserIds: activeChannel.value.userId ? [activeChannel.value.userId] : [],
    orgOrUserType: activeOrgTreeType.value,
    rolePermission: currentRolePermission.value,
  }))
  // 渠道相关的参数
  // 传入 fieldName 可以修改返回参数对应的key
  const getOrgActiveParamsByFieldName = computed<(
  fieldName?: Partial<Record<keyof OrgActiveParams, string>>,
  ) => Record<string, any>>(() => (fieldName) => {
      const defaultParams = orgActiveParams.value
      if (!fieldName)
        return defaultParams
      return mapKeys(defaultParams, (_, key) => fieldName[key as keyof typeof fieldName] || key)
    })

  function toggleCollapsed() {
    collapsed.value = !collapsed.value
  }

  function toggleShowCollapsed(show: boolean) {
    showCollapsed.value = show
  }

  function setCollapsed(status: boolean) {
    collapsed.value = status
  }

  function setActiveChannel(channel: Channel) {
    activeChannel.value = cloneDeep(channel)
    currentRolePermission.value = channel.rolePermission
    setRole(channel.rolePermission, superAdmin.value)
  }

  function setActiveOrgTreeType(orgTreeType: OrgTreeType) {
    activeOrgTreeType.value = orgTreeType
  }

  function toggleEditAble(_editable: boolean) {
    editable.value = _editable
  }

  function setChannels(channelData: Channel[]) {
    channels.value = channelData
  }

  return {
    channels,
    collapsed,
    showCollapsed,
    activeChannel,
    activeOrgTreeType,
    orgActiveParams,
    getOrgActiveParamsByFieldName,
    editable,

    toggleCollapsed,
    setChannels,
    toggleShowCollapsed,
    setActiveChannel,
    setActiveOrgTreeType,
    setCollapsed,
    toggleEditAble,
  }
})
// {
//   persist: {
//     paths: ['activeChannel'],
//   },
// }

export default store
